import React from "react"

import { AvailablePlanStatus } from "@common-shared/config/coverage.config.ts"
import { IOneVerifyCoverageResult } from "@common-shared/types/responseData/oneVerifyResponseData.types.ts"

import { TOOLTIPS_CONFIG } from "../../config/tooltips.config"
import { HtmlHelper } from "../../helpers/html.helper"

export const ActiveAtRiskPlanStatusBadgeElement: React.FunctionComponent<{
    coverageResult: IOneVerifyCoverageResult
}> = props => {
    if (props.coverageResult.planStatus !== AvailablePlanStatus.activeAtRisk) {
        return null
    }

    return HtmlHelper.getHtmlWrappedBadge(
        "Active - At Risk",
        undefined,
        TOOLTIPS_CONFIG.coverageBreakdown.activeAtRiskPlanStatus,
    )
}
